import { render, staticRenderFns } from "./InspetorNo.vue?vue&type=template&id=3cb832a2&scoped=true&"
import script from "./InspetorNo.vue?vue&type=script&lang=js&"
export * from "./InspetorNo.vue?vue&type=script&lang=js&"
import style0 from "./InspetorNo.vue?vue&type=style&index=0&id=3cb832a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb832a2",
  null
  
)

export default component.exports